import { JSX } from 'solid-js';

import { cx } from '../../utils';
import { createMultipleBind, MixedSelectProps, MultipleProps } from './Multiple';
import { createSingleBind, SingleProps } from './Single';

export function OptionItem<T>(props: SingleProps<T>) {
  const [selected, toggle, others] = createSingleBind(props);
  return (
    <button
      onClick={() => {
        toggle();
        props.onItemClick?.();
      }}
      class={cx(props.class)}
      aria-selected={utils.false2undefined(selected())}
      aria-disabled={utils.false2undefined(props.disabled)}
      {...(others as any)}
    >
      {props.children}
    </button>
  );
}

export function Radio<T>(props: SingleProps<T>) {
  return (
    <OptionItem {...props} class={cx('radio', props.class)}>
      <span class="radio-inner"></span>
      {props.children}
    </OptionItem>
  );
}

export function SelectOption<T>(props: MixedSelectProps<T>): JSX.Element {
  const [selected, toggle, others] = createMultipleBind(props as any);

  return (
    <div
      onClick={toggle}
      class={cx('option', props.class)}
      aria-selected={utils.false2undefined(selected())}
      aria-disabled={utils.false2undefined(props.disabled)}
      {...(others as any)}
    >
      {props.children}
    </div>
  );
}

export function Checkbox<T>(props: MultipleProps<T>) {
  const [selected, toggle, others] = createMultipleBind(props);

  return (
    <div
      onClick={toggle}
      class={cx('checkbox', props.class)}
      aria-selected={utils.false2undefined(selected())}
      {...(others as any)}
    >
      <span class="checkbox-inner"></span>
      {props.children}
    </div>
  );
}

export function SwitchUI<T>(props: SingleProps<T>) {
  return (
    <OptionItem {...props} class={cx('switch', props.class)}>
      <span class="switch-inner"></span>
      {props.children}
    </OptionItem>
  );
}
